import React from 'react';
import News from './news';
import PropTypes from 'prop-types'


const Lista = ({news}) => (
		<div className='row'>
			{news.map(noti => (
				<News 
					key={noti.url}
					noti={noti}
				/>
			))}
		</div>
);
 
 
Lista.propTypes = {
	news: PropTypes.array.isRequired
}
export default Lista;